module.exports = __webpack_public_path__ + "static/img/dataBoard.0de757fc.png";